export const CLARITY_EVENTS = {
  PAGE_VIEW: "page_view",

  START_SCOPING_CONVERSATION_CLICKED: "start_scoping_conversation_clicked",

  SEE_OUR_WORK_CLICKED: "see_our_work_clicked",

  WHATSAPP_CLICKED: "whatsapp_clicked",

  EMAIL_CLICKED: "email_clicked",

  PHONE_CLICKED: "phone_clicked",

  CONTACT_US_FORM: "contactusform",

  GET_IN_TOUCH_CLICKED: "get_in_touch_clicked",

   BOOK_MESSAGE: "book_message",
};